<div *ngIf="isLoading" class="se-loader"></div>
<!-- Main Grid -->
<div >
  <div class="top-div">
    <div class="filter-sec pt-2 ">
      <input #filtr type="text"  aria-label="search" class="input-globalsearch"  size="50"
             placeholder={{labels.search|translate}} title={{labels.driverUploadSearch|translate}}
             (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
      <button class="se-button cursorPointerHand" (click)="onShowUploadModal()">
        {{ "Upload" | translate }}
      </button>
    </div>
  </div>
  <div class="gridtbl-div mb-3">
    <div class="rectangle-grid">
      <p-table #dt [columns]="cols" [value]="driversList" [paginator]="isPagination" [rows]="10"  [globalFilterFields]="['fileName','mask','uploadedBy']">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width, 'display': col.display}">
              {{col.header | translate}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
            </th>
            <th scope="col" class="headerCol">{{ labels.actions | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr class="rowHeight">
            <td *ngFor="let col of columns">
              <span appendTo="target" class="relativePosition" *ngIf="col.field !== 'uploadedOn'">
                {{ rowData[col.field ] }}
              </span>
              <span *ngIf="col.field === 'uploadedOn'" appendTo="target" class="relativePosition">
                {{ rowData[col.field] | date : 'dd-MM-yyyy HH:mm' }}
              </span>
            </td>
            <td>
              <img src="assets/action_download.svg" alt="Download" width="150px" height="150px" class="download_icn" title="Download" (click)="download(rowData)"
                   (keypress)="download(rowData)"
                   (keydown)="download(rowData)"
                   (keyup)="download(rowData)" />
              <img src="assets/delete.svg" class="icon-action" title="Delete" (click)="deleteDriver(rowData)"
                   (keypress)="deleteDriver(rowData)"
                   (keydown)="deleteDriver(rowData)"
                   (keyup)="deleteDriver(rowData)" alt="Download" width="150px" height="150px"/>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr *ngIf="noData">
            <td [attr.colspan]="columns.length+1">
              {{labels.noRecords | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Upload Modal -->
<div class="se-dialog" *ngIf="showUploadModal">
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{contentHeader| translate}}</h3>
    </div>
    <div class="se-dialog-body">
      <div class="se-inline-form">
        <div class="form-ele col-md-12">
          <label for="txtMask" class="se-label col-md-3 mt-2">{{labels.mask | translate}}<span>*</span></label>
          <input id="txtMask" name="txtMask" placeholder="Mask" autocomplete="off" type="text" appRequiredElementValidator class="se-form-control" #Mask="ngModel" [(ngModel)]="mask" [minLength]="1" [maxLength]="20" (keyup)="ValidateForm()" />
          <div class="d-block brand-error se-fs-12" *ngIf="formInvalid && (Mask.dirty || Mask.touched)">
            {{ requiredMask }}
          </div>
        </div>
        <div class="form-ele col-md-12 upload-ctrl">
          <label class="se-label col-md-3">Driver File<span>*</span></label>
          <div class="col-md-9">
            <input id="txtFile" aria-label="file" [disabled]="formInvalid" for="txtFile" placeholder=".xml" type="text" class="se-form-control col-md-2" [(ngModel)]="fileNameModel" name="driverFile" (keydown)="FileKeyDownText($event);">
            <img width="150px" height="150px" class="uploadimage" src="assets/action_upload.svg" alt="Upload">
            <input type="file" aria-label="fileUploadEvent" class="browseimg uploadimage" [disabled]="formInvalid" accept="text/xml" (change)="UploadFileEvent($event)">
          </div>
        </div>
        <div class="col-md-12">
          <div class="d-block brand-error se-fs-12" *ngIf="!isValidFile">
            {{ "Invalid file type" }}
          </div>
        </div>
      </div>
    </div>
    <div class="se-dialog-footer">
      <button id="uploadCancel" class="se-button" (click)="cancel()">{{labels.cancel | translate}}</button>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="showWarningmodal">
  <div class="se-dialog-holder">
    <div class="se-complex-header se-warning">
      <h3 class="se-dialiog-title" *ngIf="!deleteflag"> {{this.labels.fileExist | translate}}</h3>
      <h3 class="se-dialiog-title" *ngIf="deleteflag"> {{this.labels.warning | translate}}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-delete">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <span *ngIf="!deleteflag">{{this.labels.overWriteMsg | translate}}</span>
      <span *ngIf="deleteflag">{{this.labels.infoMessage | translate}}</span>

    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="cancel()">{{labels.no | translate}}</button>
      <button class="se-button" (click)="confirm()">{{labels.yes | translate}}</button>
    </div>
  </div>
</div>
<template ngbModalContainer>
</template>
<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
<p-toast position="center" key="c" (onClose)="cancel()" [baseZIndex]="5000"></p-toast>
